<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<keep-alive>
				<search search_type="train"></search>
				</keep-alive>
				 
				 <!-- 主体列表内容 -->
				 <div class="proTrain">
					 <div class="trainList naList">
						 <ul class="d-flex f-wrap">
							 <li v-for="(item, index) in trainVOList" :key="index">
								 <div class="text scale">
									 <figure class="pointer pr">
										 <!-- <a @click="goToPage('/onlineTrainDetail?id='+item.id)" href="javascript:;" class="ab"></a> -->
										 <img :src="item.cover" class="t-sion" alt="">
									 </figure>
									 <div class="intro">
										 <h3 class="nowrap2 h3 font20 font-medium line-sm"><a class="link" @click="goToPage('/onlineTrainDetail?id='+item.id)" href="javascript:;">{{item.title}}</a></h3>
										 <p class="nowrap1 cor999 font-light">{{item.desc}}</p>
										 <div class="date line-sm">{{item.updateTime}}</div>
										 <div class="handel d-flex j-sb a-center">
											 <div class="btns d-flex">
												 <!-- <a href="" class="entry">报名中</a> -->
												 <a href="javascript:;" @click="goToPage('/onlineTrainDetail?id='+item.id)" class="lookDetail">{{ $t('show.lookDetail') }}</a>
											 </div>
											 <!-- <span class="cor999 font-light line-sm">600</span> -->
										 </div>
									 </div>
								 </div>
							 </li>
						 </ul>
					 </div>
					 <!-- 分页 -->
					 <div class="pagination">
						 <el-pagination
							   @current-change="handleCurrentChange"
							   :page-size="10"
							   layout="prev, pager, next"
							   :total="total">
						</el-pagination>
					 </div>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
// Search组件
import search from './component/search.vue';
export default {
  name: 'ProductTrain',
  components: {
    search
  },
  data() {
    return {
		// 培训
		trainVOList: [],
		// 分页
		pagination: {
			contentType: 'train',
			pageNo: 1,
			pageSize: 10,
			productId: ''
		},
		// 数量
		total: 0
	}
  },
  
  created() {
  	this.pagination.productId = this.$route.query.productId;
  	// 获取培训列表
  	this.getTrainVOList();
  },
  
  methods: {
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 获取文档
	  getTrainVOList() {
	  		  this.$axios.post(`product/otherPage`, this.pagination)
	  		  .then(res => {
	  			  let data = res.data;
	  			  this.trainVOList = data.list;
	  			  this.total = data.total;
	  		  })
	  		  .catch(err=>{})
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getDocumentVOList();
	  }
  }
}
</script>

<style lang="less" scoped>
	
</style>
